import React, { lazy, useRef } from "react";

import TestIds from "../../testIds";
import DateType from "../../types/Date";
import {
    AttachmentWrapper,
    CenteredIcon,
    ContentWrapper,
    Header,
    MessageIconWrapper,
    MessageSubject,
    StyledMessage
} from "./ChatMessage.styles";
import { IChatMessage } from "./ChatMessage.utils";
import ChatMessageAttachments from "./ChatMessageAttachments";
import { Linkify } from "@components/chatMessage/Linkify";

interface IProps extends IChatMessage {
    isGrouped?: boolean;
}

const ChatMessage: React.FC<IProps> = (props) => {
    const {
        icon,
        created, createdBy,
        subject, text,
        attachments,
        type
    } = props;

    const _messageRef = useRef<HTMLDivElement>();

    return (
        <StyledMessage ref={_messageRef}
                       $type={type}
                       data-testid={TestIds.Message}>
            <MessageIconWrapper $type={type}>
                <CenteredIcon>{icon}</CenteredIcon>
            </MessageIconWrapper>
            <ContentWrapper $type={type} data-testid={TestIds.MessageContent}>
                {subject && <MessageSubject>{subject}</MessageSubject>}
                <Linkify text={text}/>
                {attachments?.length > 0 &&
                    <AttachmentWrapper $hasText={!!text}
                                       data-testid={TestIds.Attachment}>
                    <ChatMessageAttachments attachments={attachments}/>
                    </AttachmentWrapper>
                }
                {(created || createdBy) &&
                    <Header $type={type}>
                        {DateType.localFormat(created, DateType.defaultDateTimeFormat)} ({createdBy})
                    </Header>}
            </ContentWrapper>
        </StyledMessage>
    );
};

export default ChatMessage;